import { Nullable, PageViewModel, ServerResponse, TableSelectOption } from '@/types';

export type PfcDescriptionItem = {
  id: number;
  isUnderConsideration: boolean;
  meaning: Nullable<string>;
};

export type PfcTableDataItem = {
  id: number;
  isMapped: boolean;
  pfc: string;
  pfcDescription: PfcDescriptionItem;
};

export type PfcTableData = {
  count: number;
  countNotMapped: number;
  isDataAvailable: boolean;
  pageViewModel: PageViewModel;
  tableData: PfcTableDataItem[];
};

export enum PfcMappingColumns {
  pfc = 'pfc',
  pfcDescription = 'pfcDescription',
}

export type PfcMappingDataResponse = ServerResponse<PfcTableData>;

export type PFCMeaningItem = {
  id: number;
  meaning: string;
};

export type PFCMeaningResponse = ServerResponse<{ meanings: PFCMeaningItem[] }>;

export type PfcMappingTableProps = {
  selectOptions: PFCMeaningItem[];
};

export type PfcMappingRow = {
  id: number;
  meaningId: number;
};

export type PfcRowRequestItem = {
  mapRow: PfcMappingRow & { pfCode: string };
};

export type PfcDefinitionParams = {
  comment: string;
  definition: string;
  pfcMappingId: number;
};

export type PfcMappingEditTableHookProps = {
  meaningOptions: TableSelectOption[];
  onMeaningChange: (rowId: number, meaningId: number) => void;
};
